interface ToastProps {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
}

// Removed unused ToastState interface

// Removed unused toastTimeouts

let toastCount = 0;

function genId() {
  toastCount = (toastCount + 1) % Number.MAX_SAFE_INTEGER;
  return toastCount.toString();
}

export function toast({ title, description, variant = "default" }: ToastProps) {
  const id = genId();

  // Simple console implementation for now
  if (variant === "destructive") {
    console.error(`Toast: ${title}${description ? ` - ${description}` : ""}`);
  } else {
    console.log(`Toast: ${title}${description ? ` - ${description}` : ""}`);
  }

  return {
    id,
    dismiss: () => {
      // No-op for now
    },
  };
}

export function useToast() {
  return {
    toast,
  };
}
